import { SubmissionError } from 'redux-form';

export const USERS_TAG = 'Users';

export const SET_ALERTS = 'SET_ALERTS';
export const SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION';
export const SET_AUTH_USER = 'SET_AUTH_USER';

export const setActiveSection = section => {
  return {
    type: SET_ACTIVE_SECTION,
    section
  };
};

export const setAlerts = alerts => {
  return {
    type: SET_ALERTS,
    alerts
  };
};

export const setAuthUser = user => {
  return {
    type: SET_AUTH_USER,
    user
  };
};

export const addNewAlert = alert => {
  return async (dispatch, getState) => {};
};

export const setUserFromToken = accessToken => {
  return async (dispatch, getState, { apiClient, feathersClient }) => {
    const jtw = await feathersClient.passport.verifyJWT(accessToken);

    if (!jtw || !jtw.userId) {
      await apiClient.setBearerAuthToken(null);
      return;
    }

    await apiClient.setBearerAuthToken(accessToken);

    const user = await apiClient.call(USERS_TAG, 'getUser', { id: jtw.userId });

    if (!user) {
      await apiClient.setBearerAuthToken(null);
      return;
    }

    dispatch(setAuthUser(user));
  };
};

export const loginWithCredentials = (payload, callback) => {
  const { username, password } = payload;
  return async (dispatch, getState, { apiClient, feathersClient }) => {
    try {
      const res = await feathersClient.authenticate({
        strategy: 'local',
        email: username,
        password
      });

      if (!res) {
        throw new SubmissionError({ _error: 'Empty Response...' });
      }

      await dispatch(setUserFromToken(res.accessToken));

      callback && callback();
    } catch (error) {
      if (!(error instanceof SubmissionError)) {
        throw new SubmissionError({ _error: error.message });
      } else {
        throw error;
      }
    }
  };
};

export const logout = () => {
  return async (dispatch, getState, { apiClient, feathersClient }) => {
    await feathersClient.app.logout();
    dispatch(setAuthUser(null));
  };
};



// WEBPACK FOOTER //
// ./src/data/actions.js